import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { PageHero } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";
import { IMAGES } from "../content/defaultContent";

export default function Why() {
  const { content } = useLanguage();
  const w = content.why;
  return (
    <div data-testid="why-page">
      <PageHero overline={w.hero.overline} title={w.hero.title} subtitle={w.hero.subtitle} image={IMAGES.hero} />

      <section className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid grid-cols-1 gap-x-16 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
            {w.reasons.map((r, i) => (
              <Reveal key={i} variant="up" delay={(i % 3) * 0.1} className="border-t border-brand-green/15 pt-8">
                <span className="font-mono text-sm text-brand-gold">0{i + 1}</span>
                <h3 className="mt-5 font-serif text-2xl text-brand-green">{r.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-brand-black/70">{r.text}</p>
              </Reveal>
            ))}
          </div>

          <Reveal variant="up" className="mt-20 border border-brand-green/15 bg-brand-beige p-12 text-center md:p-16">
            <p className="mx-auto max-w-2xl font-serif text-3xl font-light leading-tight text-brand-green md:text-4xl">
              {content.home.cta.title}
            </p>
            <Link
              to="/contact"
              data-testid="why-contact-btn"
              className="mt-8 inline-block rounded-none bg-brand-green px-10 py-5 text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-brand-black"
            >
              {content.ui.nav.contact}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
